module.exports = __webpack_public_path__ + "assets/hamburger_active-3cf89b.svg";